import { render, staticRenderFns } from "./imageTextClassify.vue?vue&type=template&id=3460337b&scoped=true&"
import script from "./imageTextClassify.vue?vue&type=script&lang=ts&"
export * from "./imageTextClassify.vue?vue&type=script&lang=ts&"
import style0 from "./imageTextClassify.vue?vue&type=style&index=0&id=3460337b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460337b",
  null
  
)

export default component.exports